/**
 * Per-org storage usage table with quota bars.
 *
 * Extracted verbatim from StorageFilesTab.jsx during the Phase 6 refactor
 * (no behaviour change).
 */
import { HardDrive, RefreshCw } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { formatBytes } from '../../../utils/uploadImage';
import { QuotaEditor } from './QuotaEditor';

export function OrgUsageTable({ usage, isSuperAdmin, onRefresh, onQuotaSave }) {
  return (
    <section className="rounded-lg border overflow-hidden">
      <div className="px-4 py-3 border-b flex items-center justify-between">
        <h3 className="font-semibold flex items-center gap-2"><HardDrive className="w-4 h-4" />Org usage</h3>
        <Button size="sm" variant="outline" onClick={onRefresh} data-testid="storage-refresh-btn">
          <RefreshCw className="w-4 h-4" />
        </Button>
      </div>
      <table className="w-full text-sm">
        <thead className="bg-muted/40">
          <tr>
            <th className="text-left p-3">Organization</th>
            <th className="text-left p-3">Used</th>
            <th className="text-left p-3">Files</th>
            <th className="text-left p-3 hidden md:table-cell">Quota</th>
            <th className="text-left p-3">% Used</th>
            {isSuperAdmin && <th className="p-3 w-12"></th>}
          </tr>
        </thead>
        <tbody>
          {usage.map(o => {
            const pct = o.quota_bytes ? Math.min(100, (o.total_bytes / o.quota_bytes) * 100) : null;
            return (
              <tr key={o.org_id} className="border-t" data-testid={`storage-org-row-${o.org_id}`}>
                <td className="p-3 font-medium">{o.org_name}</td>
                <td className="p-3 tabular-nums">{formatBytes(o.total_bytes)}</td>
                <td className="p-3 tabular-nums">{o.file_count}</td>
                <td className="p-3 tabular-nums hidden md:table-cell">{o.quota_bytes ? formatBytes(o.quota_bytes) : <span className="text-muted-foreground">unlimited</span>}</td>
                <td className="p-3">
                  {pct == null ? (
                    <span className="text-muted-foreground text-xs">—</span>
                  ) : (
                    <div className="flex items-center gap-2">
                      <div className="flex-1 h-1.5 rounded-full bg-muted overflow-hidden max-w-[120px]">
                        <div
                          className="h-full"
                          style={{ width: `${pct}%`, backgroundColor: pct > 90 ? '#DC2626' : pct > 70 ? '#D97706' : '#059669' }}
                        />
                      </div>
                      <span className="text-xs tabular-nums">{pct.toFixed(0)}%</span>
                    </div>
                  )}
                </td>
                {isSuperAdmin && (
                  <td className="p-3 text-right">
                    <QuotaEditor row={o} onSave={(gb) => onQuotaSave(o.org_id, gb)} />
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
}
